import { css, type Theme } from "@emotion/react";

import { dimensions } from "@styles";

export const column = css`
  max-width: 28.125rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 0;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    padding: 2rem 0;
  }
`;

export const centerAlignedText = css`
  text-align: center;
`;
export const centerAlignedDesktopText = css`
  @media (min-width: ${dimensions.phoneLargeMax}) {
    text-align: center;
  }
`;

export const contentContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1.5rem;
  flex: 1;
`;

export const dividerLine = (theme: Theme) => css`
  border-top: 1px solid ${theme.system.backgroundMutedActive};
`;
